export const TAB_NAMES = {
    1: 'basic',
    2: 'standard',
    3: 'premium',
  };
  